<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_manageemployee/_import/import.vue'
export default {
  components: {
    createContent
  }
}
</script>
